import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'empresas/tipos-de-servicios-de-policias';

/**
 * GET Tipos de Servicios de Policias
 * @returns {Promise<Array<object>>}
 */
export const getTiposDeServiciosDePolicias = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Tipo de Servicio de Policia
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getTipoDeServicioDePolicia = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Tipo de Servicio de Policia
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postTipoDeServicioDePolicia = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Tipo de  Servicio de Policia
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchTipoDeServicioDePolicia = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Tipo de Servicio de Policia
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteTipoDeServicioDePolicia = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
